export default __webpack_public_path__ + "static/media/comment.b8d2cace.svg";